import { createContext, useContext } from 'react';

import { type TabbarProps } from '@widgets/tabbar';

export interface BottomSheetConfig {
  isAbsolute?: boolean;
}

export interface TabbarContextType extends TabbarProps {
  setShowNavigation: (value: boolean) => void;
  setShowBottomSheet: (value: boolean) => void;
  setBottomSheet: (value: React.ReactNode, config?: BottomSheetConfig) => void;
}

export const TabbarContext = createContext<TabbarContextType | undefined>(
  undefined,
);

export const useTabbar = () => {
  const context = useContext(TabbarContext);

  if (!context) {
    throw new Error('useTabbar must be used within a TabbarProvider');
  }

  return context;
};
